var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"white","stroke":"#6B6B6B","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M4 20h4L18.5 9.5a1.5 1.5 0 0 0-4-4L4 16v4m9.5-13.5l4 4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }